<div fxLayout="row">
  <div fxFlex="0 0 48px" class="u-textAlign-center">
    <mat-icon class="md-24 color-grey-300 u-display-block"
      >access_time</mat-icon
    >
  </div>
  <div fxFlex="0 0 calc(100% - 48px)" class="text-body-2">
    <b>{{ event.event_start_date | date: 'fullDate' }}</b>
    <div class="color-grey-300">
      {{ event.event_start_date | date: 'shortTime' }} -
      {{ event.event_end_date | date: 'shortTime' }}
    </div>
  </div>
</div>
